module.exports = __webpack_public_path__ + "img/theme8.a1be9832.png";